<page-toolbar [pageActions]="pageActions" [title]="title"></page-toolbar>

<page-content *ngIf="isLoaded">
  <mat-card appearance="outlined">
    <mat-card-title>Details</mat-card-title>
    <mat-list>
      <mat-list-item><span class="label">Id: </span><span>{{customer._id}}</span></mat-list-item>
      <mat-list-item><span class="label">OrganisationName: </span><span>{{customer.organisationName}}</span></mat-list-item>
      <mat-list-item><span class="label">Price Model: </span><span>{{priceModelMap[customer.priceModel]}}</span></mat-list-item>
      <mat-list-item><span class="label">Vip Support: </span>
        <span>
        <i *ngIf="customer.support" class="material-icons">check_box</i>
        <i *ngIf="!customer.support" class="material-icons">indeterminate_check_box</i>
      </span>
      </mat-list-item>

      <mat-list-item *ngIf="customer.name"><span class="label">Name: </span>
        <span>{{customer.name.title}} {{customer.name.firstName}} {{customer.name.lastName}}</span>
      </mat-list-item>
      <mat-list-item *ngIf="customer.address"><span class="label">Address: </span>
        <span>{{customer.address.street}}, {{customer.address.zip}} {{customer.address.city}}</span>
      </mat-list-item>
      <mat-list-item *ngIf="customer.contact"><span class="label">contact: </span>
        <span>Tel: {{customer.contact.tel}} </span><span>Website:{{customer.contact.url}}</span><span>Mail: {{customer.contact.mail}}</span>
      </mat-list-item>
      <mat-list-item *ngIf="customer.licences">
        <span class="label">Licences: </span>
        <span>kioskTablet: {{customer.licences.kioskTablet}}</span><span>kioskScreen: {{customer.licences.kioskScreen}}</span>
      </mat-list-item>
      <mat-list-item *ngIf="customer.hardware"><span class="label">Hardware: </span>
        <span>40inch: {{customer.hardware.inch40}} </span> <span> 48inch: {{customer.hardware.inch48}} </span>
        <span>55inch: {{customer.hardware.inch55}} </span>
      </mat-list-item>
      <mat-list-item><span class="label">Comment: </span><span>{{customer.comment}}</span></mat-list-item>
    </mat-list>
  </mat-card>

  <div class="spacer"></div>

  <ng-container *ifPrivilege="{name: 'read', value: 'angie-screens'}">
    <data-table (detail)="onDetailScreen($event)" *ngIf="uuids" [columns]="columnsScreen" [dataProviderParams]="paramsScreen"
                [dataProvider]="angieScreensService" [hideSearch]="true" [title]="'Screens'"></data-table>
  </ng-container>

  <div class="spacer"></div>

  <data-table (detail)="onDetailPackage($event)" *ifPrivilege="{name: 'write', value: 'packages'}" [columns]="columnsPackage"
              [dataProviderParams]="paramsPackage" [dataProvider]="packageService" [hideSearch]="true" [title]="'Packages'">
  </data-table>

  <div class="spacer"></div>

  <ng-container *ifPrivilege="{name: 'read', value: 'compositions'}">
    <data-table (detail)="onDetailComposition($event)" *ngIf="compositionIds" [columns]="columnsComposition"
                [dataProviderParams]="paramsComposition" [dataProvider]="compositionService" [hideSearch]="true" [title]="'Compositions'">
    </data-table>
  </ng-container>

  <div class="spacer"></div>

  <data-table (detail)="onDetailDynamicContent($event)" *ifPrivilege="{name: 'read', value: 'dynamic-content-entrances'}"
              [columns]="columnsDynamicEntrance" [dataProviderParams]="paramsDynamicEntrance" [dataProvider]="dynamicContentEntranceService"
              [hideSearch]="true" [title]="'Dynamic Entrances'"></data-table>

</page-content>
